export const DEFAULT_STATE = 'DEFAULT_STATE';
export const ARROW_STATE = 'ARROW_STATE';
export const EMPTY_STATE = 'EMPTY_STATE';
export const DIRECTION_PREV = 'DIRECTION_PREV';
export const DIRECTION_NEXT = 'DIRECTION_NEXT';
export const DEFAULT_FIRST_ITEM = 1;
export const MAX_DESKTOP_ITEMS = 7;
export const MAX_MOBILE_ITEMS = 5;
export const DEFAULT_ACTIVE_PER_PAGE_VALUE = 1;
